module.exports = __webpack_public_path__ + "static/fonts/c4be5717-c19c-43a5-9ad3-b548ddf070d4.29d5f41.eot";